import BaseViz from './BaseViz'
import ParallelCoordsChart from '../charts/ParallelCoordsChart'
import ParallelCoordsDataController from '../viz_behaviors/ParallelCoordsDataController'
export default class RadarChartViz extends BaseViz {
  static defaultConfig = {
    showPoints: true,
    AxisHelper: {
      zoom: {
        nonEditable: true,
      },
      x: {
        dimensions: null,
        grid: false,
        tickOrientation: {
          nonEditable: true,
        },
        trimThreshold: {
          nonEditable: true,
        },
        valueFormat: {
          nonEditable: true,
        },
        unit: {
          nonEditable: true,
        },
        scale: {
          nonEditable: true,
        },
        tickMatchData: {
          nonEditable: true,
          exposed: false,
        },
      },
      y: {
        // tickFormat: ()=>'',
        grid: false,
        tickOrientation: {
          nonEditable: true,
        },
        // getExtent: function(data,dimLabel){
        //   return [0,100]
        // },
        trimThreshold: {
          nonEditable: true,
        },
        scale: {
          nonEditable: true,
        },
        unit: {
          nonEditable: true,
        },
      },
    },
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical'],
        nonEditable: true,
      },
      colorMode: 'stroke',
    },
    LegendBehavior: {
      icon: 'line',
    },
  }
  static chartClass = ParallelCoordsChart
  static dataControllerClass = ParallelCoordsDataController
}
